var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { fork, put, spawn } from 'redux-saga/effects';
import uniqueId from 'uniqid';
import { getIsClient } from '../../../utils';
import { INIT_LOAD_MANAGER_EVENT_NAME } from '../constants';
import { spawnedFetchProcessSaga } from './spawned-fetch-process-saga';
import { extraRequestProcessSaga } from './extra-request-process-saga';
export function initLoadManagerWorkerSaga(_a) {
    var _b, errorLoggerGlobal, setModalAction, isNode, subprocessMethod, counterRequests, counterOfEndedRequestProcesses, eventToCatchEndedProcesses;
    var _c;
    var dispatch = _a.dispatch, eventNameToCancelRequests = _a.eventNameToCancelRequests, requestConfigList = _a.requestConfigList, _d = _a.options, _e = _d === void 0 ? {} : _d, _f = _e.requestsSectionId, requestsSectionId = _f === void 0 ? uniqueId('fetch_default_section') : _f, fullActionLoadingStop = _e.fullActionLoadingStop, fullActionLoadingStart = _e.fullActionLoadingStart, setAppErrorAction = _e.setAppErrorAction, requestBeforeAllConfig = _e.requestBeforeAllConfig, errorLogger = _e.errorLogger, callbackOnFinish = _e.callbackOnFinish, callbackOnStart = _e.callbackOnStart, store = _a.store;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                _b = (_c = store === null || store === void 0 ? void 0 : store.dependencies) !== null && _c !== void 0 ? _c : {}, errorLoggerGlobal = _b.errorLoggerGlobal, setModalAction = _b.setModalAction;
                isNode = !getIsClient();
                subprocessMethod = isNode ? fork : spawn;
                if (requestConfigList.length === 0) {
                    console.warn('please, provide non empty requestConfigList');
                    return [2 /*return*/];
                }
                if (!requestBeforeAllConfig) return [3 /*break*/, 2];
                return [5 /*yield**/, __values(extraRequestProcessSaga(requestBeforeAllConfig))];
            case 1:
                _g.sent();
                _g.label = 2;
            case 2:
                counterRequests = 0;
                counterOfEndedRequestProcesses = 0;
                eventToCatchEndedProcesses = INIT_LOAD_MANAGER_EVENT_NAME + "_" + requestsSectionId;
                if (!!isNode) return [3 /*break*/, 5];
                document.addEventListener(eventToCatchEndedProcesses, function endProcessCallback(event) {
                    // increment the counter if the request matches
                    if (event.detail.id === requestsSectionId) {
                        counterOfEndedRequestProcesses += 1;
                    }
                    if (counterOfEndedRequestProcesses === requestConfigList.length) {
                        // dispatch the loadingStop action
                        if (fullActionLoadingStop) {
                            dispatch(fullActionLoadingStop());
                        }
                        if (callbackOnFinish) {
                            callbackOnFinish({
                                dispatch: dispatch,
                                store: store,
                            });
                        }
                        // remove listener to end the whole list of requests
                        document.removeEventListener(eventToCatchEndedProcesses, endProcessCallback, true);
                    }
                }, true);
                if (!fullActionLoadingStart) return [3 /*break*/, 4];
                return [4 /*yield*/, put(fullActionLoadingStart())];
            case 3:
                _g.sent();
                _g.label = 4;
            case 4:
                if (callbackOnStart) {
                    callbackOnStart({
                        dispatch: dispatch,
                        store: store,
                    });
                }
                _g.label = 5;
            case 5:
                if (!(counterRequests < requestConfigList.length)) return [3 /*break*/, 7];
                return [4 /*yield*/, subprocessMethod(spawnedFetchProcessSaga, __assign(__assign({}, requestConfigList[counterRequests]), { requestsSectionId: requestsSectionId, setAppErrorAction: setAppErrorAction, eventNameToCancelRequests: eventNameToCancelRequests, eventToCatchEndedProcesses: eventToCatchEndedProcesses, store: store, dispatch: dispatch, errorLogger: errorLogger ||
                            requestConfigList[counterRequests].errorLogger ||
                            errorLoggerGlobal, counterRequests: counterRequests, setModalAction: setModalAction }))];
            case 6:
                _g.sent();
                // go to next request
                counterRequests += 1;
                return [3 /*break*/, 5];
            case 7: return [2 /*return*/];
        }
    });
}
